import palette from "assets/theme/base/palette";
import React, { useCallback, useEffect, useState } from "react";
import { useMaterialUIController } from "context";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import Grid from "@mui/material/Grid";
import Card from "@mui/material/Card";
import Icon from "@mui/material/Icon";
import IconButton from "@mui/material/IconButton";
import Tooltip from "@mui/material/Tooltip";
import Button from "@mui/material/Button";
import Autocomplete from "@mui/material/Autocomplete";
import Checkbox from "@mui/material/Checkbox";
import TextField from "@mui/material/TextField";
import CheckBoxIcon from "@mui/icons-material/CheckBox";
import CheckBoxOutlineBlankIcon from "@mui/icons-material/CheckBoxOutlineBlank";

import MDBox from "components/MDBox";
import MDAlert from "components/MDAlert";
import MDButton from "components/MDButton";
import MDInput from "components/MDInput";
import MDTypography from "components/MDTypography";

import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import ComplexStatisticsCard from "examples/Cards/StatisticsCards/ComplexStatisticsCard";
import DataTable from "examples/Tables/DataTable";

import { useNavigate, useLocation } from "react-router-dom";
import { call } from "services/axiosService/core";
import AdultOnBoardingScreen from "./AdultOnBoardingScreen";
import { useAuthenticator } from "@aws-amplify/ui-react";
import { CircularProgress, Divider, Chip, Avatar } from "@mui/material";
import Stack from "@mui/material/Stack";
import Snackbar from "@mui/material/Snackbar";
import MuiAlert from "@mui/material/Alert";
import Loader from "pages/loader/Loader";
import * as Sentry from "@sentry/browser";
import Bot from "pages/bot/Bot";
import ConfirmDialog from "examples/Dialog/ConfirmDialog";
import { FormLabel } from "@mui/material";
import { useTranslation, Trans } from "react-i18next";
import FolderSharedIcon from "@mui/icons-material/FolderShared";

import Antelope from "assets/images/insights/antelope.png";
import Bear from "assets/images/insights/bear.png";
import Beaver from "assets/images/insights/beaver.png";
import Bee from "assets/images/insights/bee.png";
import Bobcat from "assets/images/insights/bobcat.png";
import Buffalo from "assets/images/insights/buffalo.png";
import Cat from "assets/images/insights/cat.png";
import Chameleon from "assets/images/insights/chameleon.png";
import Cheetah from "assets/images/insights/cheetah.png";
import Deer from "assets/images/insights/deer.png";
import Dolphin from "assets/images/insights/dolphin.png";
import Eagle from "assets/images/insights/eagle.png";
import Elephant from "assets/images/insights/elephant.png";
import Fox from "assets/images/insights/fox.png";
import GermanShepherd from "assets/images/insights/german-shepherd.png";
import Giraffe from "assets/images/insights/giraffe.png";
import GoldenRetriever from "assets/images/insights/golden-retriever.png";
import Hawk from "assets/images/insights/hawk.png";
import Kangaroo from "assets/images/insights/kangaroo.png";
import Koala from "assets/images/insights/koala.png";
import Leopard from "assets/images/insights/leopard.png";
import Lion from "assets/images/insights/lion.png";
import Meerkat from "assets/images/insights/meerkat.png";
import Moose from "assets/images/insights/moose.png";
import Mustang from "assets/images/insights/mustang.png";
import Orca from "assets/images/insights/orca.png";
import Otter from "assets/images/insights/otter.png";
import Owl from "assets/images/insights/owl.png";
import Panda from "assets/images/insights/panda.png";
import Panther from "assets/images/insights/panther.png";
import Peacock from "assets/images/insights/peacock.png";
import Penguin from "assets/images/insights/penguin.png";
import Puppy from "assets/images/insights/puppy.png";
import Rabbit from "assets/images/insights/rabbit.png";
import Rhino from "assets/images/insights/rhino.png";
import Shark from "assets/images/insights/shark.png";
import Sheep from "assets/images/insights/sheep.png";
import Squirrel from "assets/images/insights/squirrel.png";
import Tiger from "assets/images/insights/tiger.png";
import Turtle from "assets/images/insights/turtle.png";
import Wolf from "assets/images/insights/wolf.png";
import Zebra from "assets/images/insights/zebra.png";
import DefaultImage from "assets/images/insights/defaultInsight.png";

const Animals = {
  Antelope,
  Bear,
  Beaver,
  Bee,
  Bobcat,
  Buffalo,
  Cat,
  Chameleon,
  Cheetah,
  Deer,
  Dolphin,
  Eagle,
  Elephant,
  Fox,
  GermanShepherd,
  Giraffe,
  GoldenRetriever,
  Hawk,
  Kangaroo,
  Koala,
  Leopard,
  Lion,
  Meerkat,
  Moose,
  Mustang,
  Orca,
  Otter,
  Owl,
  Panda,
  Panther,
  Peacock,
  Penguin,
  Puppy,
  Rabbit,
  Rhino,
  Shark,
  Sheep,
  Squirrel,
  Tiger,
  Turtle,
  Wolf,
  Zebra,
};

const RequiredLabel = ({ children }) => {
  const { t } = useTranslation();
  return (
    <FormLabel
      sx={{ display: "flex", alignItems: "center", margin: "10px auto 5px", fontSize: "15px" }}
    >
      <span style={{ color: "red", fontSize: "small", marginRight: "5px" }}>*</span>
      {children}
      <span style={{ color: "red", fontSize: "small", marginLeft: "10px" }}>
        {t("formLabels.required")}
      </span>
    </FormLabel>
  );
};

const ViewInsightsButton = ({ id, user_id, t }) => {
  const navigate = useNavigate();
  return (
    <Tooltip title={<h2 style={{}}>{t("toolTips.viewInsights")}</h2>}>
      <MDTypography
        variant="body1"
        color="secondary"
        lineHeight={1}
        sx={{ cursor: "pointer", mx: 1 }}
      >
        <Icon
          fontSize="medium"
          color="inherit"
          onClick={() => navigate(`/insight/${id}/${user_id}`)}
        >
          psychology
        </Icon>
      </MDTypography>
    </Tooltip>
  );
};

const InsightControlAccessButton = ({ row, setControlAccessRow, t }) => {
  return (
    <Tooltip title={<h2 style={{}}>{t("toolTips.insightAccess")}</h2>}>
      <MDTypography
        variant="body1"
        color="secondary"
        lineHeight={1}
        sx={{ cursor: "pointer", mx: 1 }}
      >
        <Icon fontSize="medium" color="inherit" onClick={() => setControlAccessRow(row)}>
          folder_shared
        </Icon>
      </MDTypography>
    </Tooltip>
  );
};

const RemoveAccessButton = ({ id, deleteInsightAccessHandler, t }) => {
  return (
    <Tooltip fontSize="large" title={<h2 style={{}}>{t("toolTips.removeAccess")}</h2>}>
      <MDTypography
        variant="body1"
        color="secondary"
        lineHeight={1}
        sx={{ cursor: "pointer", mx: 1 }}
      >
        <Icon
          fontSize="medium"
          color="error"
          onClick={() => {
            deleteInsightAccessHandler(id);
          }}
        >
          delete
        </Icon>
      </MDTypography>
    </Tooltip>
  );
};

const EditFilterButton = ({ row, editFilterOpenHandler, t }) => {
  return (
    <Tooltip fontSize="large" title={<h2 style={{}}>{t("toolTips.edit")}</h2>}>
      <MDTypography
        variant="body1"
        color="secondary"
        lineHeight={1}
        sx={{ cursor: "pointer", mx: 1 }}
      >
        <Icon
          fontSize="medium"
          color="info"
          onClick={() => {
            editFilterOpenHandler(row);
          }}
        >
          edit
        </Icon>
      </MDTypography>
    </Tooltip>
  );
};

const DeleteFilterButton = ({ row, deleteFilterOpenHandler, t }) => {
  return (
    <Tooltip fontSize="large" title={<h2 style={{}}>{t("toolTips.delete")}</h2>}>
      <MDTypography
        variant="body1"
        color="secondary"
        lineHeight={1}
        sx={{ cursor: "pointer", mx: 1 }}
      >
        <Icon
          fontSize="medium"
          color="error"
          onClick={() => {
            deleteFilterOpenHandler(row);
          }}
        >
          delete
        </Icon>
      </MDTypography>
    </Tooltip>
  );
};

const SendNotificationButton = ({ id, sendNotificationHandler, t }) => {
  return (
    <Tooltip fontSize="large" title={<h2 style={{}}>{t("toolTips.sendNotification")}</h2>}>
      <MDTypography
        variant="body1"
        color="secondary"
        lineHeight={1}
        sx={{ cursor: "pointer", mx: 1 }}
      >
        <Icon
          fontSize="medium"
          color="info"
          onClick={() => {
            sendNotificationHandler(id);
          }}
        >
          email
        </Icon>
      </MDTypography>
    </Tooltip>
  );
};

const MiniWave = ({ color }) => (
  <svg width="110" height="26" viewBox="0 0 110 26" fill="none">
    <path d="M0 13 Q13.75 4 27.5 13 Q41.25 22 55 13 Q68.75 4 82.5 13 Q96.25 22 110 13"
      stroke={color} strokeWidth="1.8" fill="none" strokeLinecap="round" opacity="0.7" />
  </svg>
);

const DonutChart = ({ segments, total, centerLabel }) => {
  const validTotal = Math.max(total, 1);
  let cumulative = 0;
  const stops = segments
    .filter((s) => s.value > 0)
    .map((s) => {
      const pct = (s.value / validTotal) * 100;
      const stop = `${s.color} ${cumulative.toFixed(2)}% ${(cumulative + pct).toFixed(2)}%`;
      cumulative += pct;
      return stop;
    });
  const gradient = stops.length
    ? `conic-gradient(${stops.join(", ")})`
    : `conic-gradient(${palette.neutral[200]} 0% 100%)`;
  return (
    <MDBox sx={{ position: "relative", width: 140, height: 140, flexShrink: 0 }}>
      <MDBox sx={{ width: 140, height: 140, borderRadius: "50%", background: gradient }} />
      <MDBox sx={{
        position: "absolute", top: "50%", left: "50%",
        transform: "translate(-50%, -50%)",
        width: 88, height: 88, borderRadius: "50%", bgcolor: "#fff",
        display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center",
      }}>
        <MDTypography variant="h5" fontWeight="bold" lineHeight={1}>{total}</MDTypography>
        <MDTypography variant="caption" color="text.secondary" textAlign="center"
          sx={{ fontSize: "0.6rem", lineHeight: 1.3, mt: 0.25, px: 0.5 }}>
          {centerLabel}
        </MDTypography>
      </MDBox>
    </MDBox>
  );
};

const Alert = React.forwardRef(function Alert(props, ref) {
  return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
});

const assessmentStatusChip = (rawStatus, label) => {
  const map = {
    ready:         { bg: `${palette.brand[500]}18`,  color: palette.brand[500] },
    in_progress:   { bg: palette.purple[50],         color: palette.purple[500] },
    not_started:   { bg: palette.orange[50],         color: palette.orange[500] },
    not_generated: { bg: palette.green[50],          color: palette.green[500] },
  };
  const c = map[rawStatus] || map.not_generated;
  return (
    <Chip label={label} size="small"
      sx={{ bgcolor: c.bg, color: c.color, fontWeight: "bold", fontSize: "0.68rem", height: 22 }} />
  );
};

const userStatusChip = (rawStatus, label) => {
  const map = { active: { bg: "#e8f5e9", color: "#4caf50" }, inactive: { bg: "#f5f5f5", color: "#9e9e9e" }, pending: { bg: "#fff3e0", color: "#ff9800" } };
  const c = map[rawStatus?.toLowerCase()] || map.inactive;
  return (
    <Chip label={label} size="small"
      sx={{ bgcolor: c.bg, color: c.color, fontWeight: "bold", fontSize: "0.68rem", height: 22 }} />
  );
};


export function Dashboard() {
  const location = useLocation();
  const openBot = location.state?.openBot || false;
  const [controlAccessRow, setControlAccessRow] = useState(null);
  const [openFilterModel, setOpenFilterModel] = useState(false);
  const [openAddFilterModel, setOpenAddFilterModel] = useState(false);
  const [openEditFilterModel, setOpenEditFilterModel] = useState(false);
  const [openDeleteFilterModel, setOpenDeleteFilterModel] = useState(false);
  const [showInsightBar, setShowInsightBar] = useState(false);
  const [filters, setFilters] = useState([]);
  const [learners, setLearners] = useState([]);

  const [editFilterData, setEditFilterData] = useState(null);
  const [deleteFilterData, setDeleteFilterData] = useState(null);
  const [deleteFilterLoading, setDeleteFilterLoading] = useState(false);
  const { user, signOut } = useAuthenticator((context) => [context.user]);
  const [controller] = useMaterialUIController();
  const { profile, persona } = controller;
  const [loader, setLoader] = useState(true);
  const [openSnackbar, setOpenSnackbar] = useState(false);
  const [alertMessage, setAlertMessage] = useState("");
  const [severity, setSeverity] = useState("success");
  const [openLoader, setOpenLoader] = useState(false);
  const [pageNumber, setPageNumber] = useState(0);
  const [showBot, setShowBot] = useState(false);
  const [showUnreadChat, setShowUnreadChat] = useState(false);
  const [showTodayContent, setShowTodayContent] = useState(false);
  const [todayContent, setTodayContent] = useState([]);
  const [chatQuestions, setChatQuestions] = useState([]);
  const [showIntro, setShowIntro] = useState(false);
  const [autoExpandBot, setAutoExpandBot] = useState(openBot);
  const [userMetricsData, setUserMetricsData] = useState(null);
  // const [hasPaymentMethods, setHasPaymentMethods] = useState(true);
  const [showPaymentReminder, setShowPaymentReminder] = useState(false);
  const [dashboardMetrics, setDashboardMetrics] = useState(null);
  const navigate = useNavigate();
  const { t } = useTranslation();

  const handleCloseSnackbar = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setOpenSnackbar(false);
  };

  const tableData = {
    columns: [
      { Header: t("tableHeaders.name"), accessor: "learner_name_cell", width: "22%" },
      { Header: t("tableHeaders.age"), accessor: "learner_age", width: "6%" },
      { Header: t("tableHeaders.gender"), accessor: "learner_gender", align: "center" },
      { Header: t("tableHeaders.userStatus"), accessor: "learner_status", align: "center" },
      { Header: t("tableHeaders.assessment"), accessor: "assessment_name", width: "12%" },
      { Header: t("tableHeaders.animal"), accessor: "animal", width: "8%" },
      { Header: t("tableHeaders.assessmentStatus"), accessor: "assessment_status", width: "12%" },
      { Header: t("tableHeaders.completionDate"), accessor: "completion_date" },
      { Header: t("tableHeaders.actions"), accessor: "actions", width: "10%" },
    ],
    rows: learners,
  };

  useEffect(() => {
    loadLearners();
    loadFilters();
    loadPaymentMethods();
    loadDashboardMetrics();
  }, []);

  useEffect(() => {
    if (persona == "adultAthlete") {
      loadDailyChatQuestions();
      getUnreadStatus();
      getDailyContent();
      getIntroMessageStatus();
      loadUserContentMetrics();
    }
  }, [persona]);

  const loadDashboardMetrics = () => {
    if (!profile.id) return;
    call(`users/${profile.id}/dashboardmetrics`, "GET", {})
      .then((res) => {
        if (res.status === 200) {
          const data = res.data;
          console.log("data",data);
          setDashboardMetrics(data);
        }
      })
      .catch((err) => {
        Sentry.captureException(err);
        console.log(err);
      });
  }

  const loadPaymentMethods = () => {
    if (!profile.id) return;
    call(`payments/get-payment-methods/${profile.id}`, "GET", {})
      .then((res) => {
        if (res.status === 200) {
          const methods = res.data?.payment_methods || [];
          const now = new Date();
          const currentYear = now.getFullYear();
          const currentMonth = now.getMonth() + 1;
          const activeMethods = methods.filter((pm) => {
            const { exp_month, exp_year } = pm.card;
            return !(
              exp_year < currentYear ||
              (exp_year === currentYear && exp_month < currentMonth)
            );
          });
          const hasActive = activeMethods.length > 0;
          // setHasPaymentMethods(hasActive);
          if (!hasActive) {
            const today = new Date().toLocaleDateString();
            const signupAt = profile.signup_at
              ? new Date(profile.signup_at).toLocaleDateString()
              : null;
            const lastReminded = localStorage.getItem("lastPaymentReminderDate");
            const isSharedAccount = profile.type && profile.type.includes("Shared");
            const hasChildren =
              (profile.relationships?.children?.length || 0) +
              (profile.relationships?.athletes?.length || 0);
            const hasPaid = !!profile.paid_at;
            const isCoach = profile.details?.persona?.includes("Coach or League Administrator");
            const shouldRemind = (isSharedAccount || hasChildren || hasPaid) && !isCoach;
            if (signupAt && lastReminded !== today && signupAt !== today && shouldRemind) {
              setShowPaymentReminder(true);
            }
          }
        }
      })
      .catch((err) => {
        Sentry.captureException(err);
      });
  };

  const handleClosePaymentReminder = () => {
    const today = new Date().toLocaleDateString();
    localStorage.setItem("lastPaymentReminderDate", today);
    setShowPaymentReminder(false);
  };

  const handleGoToAddPaymentMethod = () => {
    handleClosePaymentReminder();
    navigate("/profile", { state: { openManagePaymentMethod: true } });
  };

  const loadUserContentMetrics = () => {
    if (profile.id) {
      call(`users/${profile.id}/contentmetrics`, "GET", {})
        .then((res) => {
          if (res.status == 200) {
            let data = res.data;
            console.log("Data is", data);
            setUserMetricsData(data);
          }
        })
        .catch((err) => {
          Sentry.captureException(err);
          console.log(err);
        });
    }
  };

  const loadDailyChatQuestions = () => {
    call(`chats/bot`, "GET", {})
      .then((res) => {
        if (res.status == 404) {
          setChatQuestions([]);
        } else if (res.status == 200) {
          let questions = res.data;
          const updatedQuestions = questions.map((item) => {
            return { ...item, userResponse: "" };
          });
          setChatQuestions([...updatedQuestions]);
        } else if (res.status == 440) {
          setChatQuestions([]);
        }
      })
      .catch((err) => {
        Sentry.captureException(err);
      });
  };

  const getIntroMessageStatus = () => {
    let currentDate = new Date().toLocaleDateString();
    let lastIntroViewed = localStorage.getItem("IntroMessageViewed") || null;
    if (currentDate != lastIntroViewed) {
      setShowIntro(true);
    }
  };

  const getUnreadStatus = () => {
    let currentDate = new Date().toLocaleDateString();
    let lastBotViewed = localStorage.getItem("lastBotViewed") || null;
    if (currentDate != lastBotViewed) {
      setShowUnreadChat(true);
    }
  };

  const getDailyContent = () => {
    let currentDate = new Date().toLocaleDateString();
    let lastContentUpdated = localStorage.getItem("lastContentUpdatedDate") || null;
    if (currentDate == lastContentUpdated) {
      let dailyContent = JSON.parse(localStorage.getItem("dailyContent")) || null;
      if (dailyContent) {
        setShowTodayContent(true);
        setTodayContent(dailyContent);
      }
    }
  };

  const loadLearners = () => {
    setLoader(true);
    setShowInsightBar(false);
    if (profile.id) {
      call(`learners/${profile.id}`, "GET", {})
        .then((res) => {
          if (res.status == 200) {
            const data = res.data;
            console.log("data", data)
            if (data.length >= 1) {
              data.sort((a, b) => (a.is_guardian > b.is_guardian ? -1 : 1));
              data.sort((a, b) => (a.learner_id == profile.id ? -1 : 1));
              setLearners(data);
              data.map((item) => {
                // if adult athlete has atleast one completed assessment show the chatbot
                if (item.learner_id == profile.id && item.assessment_status == "ready") {
                  setShowBot(true);
                }
                // If the learner is the user child and assessmet share with him only then show the Bar notification
                if (
                  (item.is_guardian == true || item.learner_id == profile.id) &&
                  item.shared_with.length == 1
                ) {
                  setShowInsightBar(true);
                }
                if (item.is_guardian == true && item.shared_with.length == 2) {
                  setShowInsightBar(true);
                }
              });
              setLoader(false);
            } else {
              setLoader(false);
            }
          } else if (res.status == 440) {
            setLoader(false);
          } else {
            setLoader(false);
          }
        })
        .catch((err) => {
          Sentry.captureException(err);
        });
    }
  };
  const loadFilters = () => {
    if (profile.id) {
      call(`filters/${profile.id}`, "GET", {})
        .then((res) => {
          if (res.status == 200) {
            setFilters(res.data.Items);
          }
        })
        .catch((err) => {
          console.log(err, "err");
          Sentry.captureException(err);
        });
    }
  };
  const closeControlAccessDialog = useCallback(
    () => setControlAccessRow(null),
    [setControlAccessRow]
  );

  const filterCloseHandler = useCallback(() => setOpenFilterModel(false), [setOpenFilterModel]);

  const addFilterCloseHandler = useCallback(
    () => setOpenAddFilterModel(false),
    [setOpenAddFilterModel]
  );

  const addFilterOpenHandler = () => {
    setOpenAddFilterModel(true);
    setOpenFilterModel(false);
  };

  const editFilterOpenHandler = (row) => {
    setEditFilterData(row);
    setOpenEditFilterModel(true);
    setOpenFilterModel(false);
  };

  const deleteFilterOpenHandler = (row) => {
    setDeleteFilterData(row);
    setOpenDeleteFilterModel(true);
    setOpenFilterModel(false);
  };

  const editFilterCloseHandler = () => {
    setOpenEditFilterModel(false);
  };

  const deleteFilterCloseHandler = () => {
    setOpenDeleteFilterModel(false);
  };

  const handleDeleteFilter = () => {
    if (!deleteFilterData) return;
    setDeleteFilterLoading(true);
    call(`filters/${deleteFilterData.id}`, "DELETE", {})
      .then((res) => {
        if (res.status == 200) {
          setOpenSnackbar(true);
          setAlertMessage(t("alerts.dashboard.filterDeletedSuccessfully"));
          loadFilters();
          deleteFilterCloseHandler();
        } else if (res.status == 440) {
          deleteFilterCloseHandler();
        } else {
          setOpenSnackbar(true);
          setAlertMessage(t("alerts.dashboard.filterDeletedError"));
          loadFilters();
          deleteFilterCloseHandler();
        }
      })
      .catch((err) => {
        setOpenSnackbar(true);
        setAlertMessage(t("alerts.dashboard.filterDeletedError"));
        Sentry.captureException(err);
      })
      .finally(() => setDeleteFilterLoading(false));
  };

  function formatToMMDDYYYY(dateStr) {
    if (!dateStr) return "–";
    const [year, month, day] = dateStr.split("-");
    return `${month}-${day}-${year}`;
  }

  tableData.rows = tableData.rows.map((row) => {
    const rawAssessmentStatus = row.assessment_status;
    const rawLearnerStatus = row.learner_status;
    return {
      ...row,
      completion_date: (
        <MDTypography variant="caption" color="text.secondary">
          {formatToMMDDYYYY(row.completion_date)}
        </MDTypography>
      ),
      learner_age: (
        <MDTypography variant="caption" color="text.secondary">{row.learner_age}</MDTypography>
      ),
      learner_gender: (
        <MDTypography variant="caption" color="text.secondary">
          {t(`userDynamicData.${row.learner_gender.toLowerCase()}`)}
        </MDTypography>
      ),
      assessment_name: (
        <MDTypography variant="caption" color="text.secondary">{row.assessment_name || "–"}</MDTypography>
      ),
      learner_name_cell: (
        <MDBox display="flex" alignItems="center" gap={1.5}>
          <Avatar src={row.profile_image_url || ""} sx={{ width: 32, height: 32, bgcolor: palette.brand[50] }}>
            <Icon sx={{ fontSize: "16px !important", color: palette.brand[400] }}>person</Icon>
          </Avatar>
          <MDTypography variant="caption" fontWeight="medium">{row.learner_name}</MDTypography>
        </MDBox>
      ),
      learner_status: userStatusChip(rawLearnerStatus, t(`userDynamicData.${rawLearnerStatus}`)),
      animal: row.animal_url ? (
        <img src={row.animal_url} title={t("insights.animal", { animalName: row.animal_name })}
          style={{ width: 36, height: 36, objectFit: "cover", borderRadius: "50%" }} alt="animal" />
      ) : row.animal_name ? (
        <img src={Animals[row.animal_name.split(" ").join("")] || DefaultImage}
          title={t("insights.animal", { animalName: row.animal_name })}
          style={{ width: 36, height: 36, objectFit: "cover", borderRadius: "50%" }} alt="animal" />
      ) : (
        <MDTypography variant="caption" color="text.secondary">–</MDTypography>
      ),
      assessment_status: assessmentStatusChip(rawAssessmentStatus, t(`userDynamicData.${rawAssessmentStatus}`)),
      actions: (
        <div style={{ display: "flex" }}>
          {rawAssessmentStatus == "ready" && (
            <ViewInsightsButton id={row.assessment_id} user_id={row.learner_id} t={t} />
          )}
          {(row.is_guardian && row.learner_age < 18 && rawAssessmentStatus == "ready") ||
          (row.learner_id == profile.id && rawAssessmentStatus == "ready") ? (
            <InsightControlAccessButton row={row} setControlAccessRow={setControlAccessRow} t={t} />
          ) : null}
        </div>
      ),
    };
  });

  const isSharedAccount = profile.type && profile.type.includes("Shared");

  const addchildrenHandler = () => {
    if (isSharedAccount) {
      setSeverity("info");
      setAlertMessage(t("alerts.profile.sharedAccountAddChildDisabled"));
      setOpenSnackbar(true);
      return;
    }
    navigate("/profile", { state: { openAddChild: true } });
  };

  /* ── dashboard computed values ── */
  const firstName = profile?.details?.name?.split(" ")[0] || "";
  const insightsCount      = learners.filter((l) => l.assessment_status === "ready").length;
  const assessmentInProgress  = learners.filter((l) => l.assessment_status === "in_progress").length;
  const assessmentNotStarted  = learners.filter((l) => l.assessment_status === "not_started").length;
  const assessmentNotGenerated = learners.filter((l) => l.assessment_status === "not_generated").length;
  const totalAssessments   = learners.length;
  const totalLearners      = dashboardMetrics?.total_learners ?? 0;
  const activeLearners     = dashboardMetrics?.active_learners ?? 0;
  const inactiveLearners   = dashboardMetrics?.inactive_learners ?? 0;
  const pendingPayments    = dashboardMetrics?.pending_payments ?? 0;
  const activePct  = totalLearners ? Math.round((activeLearners / totalLearners) * 100) : 0;
  const inactivePct = totalLearners ? Math.round((inactiveLearners / totalLearners) * 100) : 0;

  const statCards = [
    { icon: "lightbulb", color: "#00BCD4", bg: "#E0F7FA", count: insightsCount,   label: t("cardTitles.insightsCount"), sub: t("messages.dashboard.newInsightsReady") },
    { icon: "group",     color: palette.orange[500], bg: "#FFF3E0", count: totalLearners, label: t("cardTitles.childrenCount"), sub: t("messages.dashboard.acrossAllPrograms"), onClick: addchildrenHandler },
    { icon: "how_to_reg", color: "#4CAF50", bg: "#E8F5E9", count: activeLearners,  label: t("cardTitles.activeLearners"), sub: `${activePct}% of total learners` },
    { icon: "account_balance_wallet", color: "#9C27B0", bg: "#F3E5F5", count: pendingPayments, label: t("cardTitles.pendingPayments"), sub: t("messages.dashboard.requireAttention"), onClick: () => navigate("/profile") },
  ];

  const quickLinks = [
    { icon: "person_add",  color: "#4CAF50",           bg: "#E8F5E9", label: t("buttonTitles.addChild"),           onClick: addchildrenHandler },
    { icon: "menu_book",   color: palette.brand[500],  bg: `${palette.brand[500]}18`, label: t("routes.contentLibrary"), onClick: () => navigate("/contentlibrary") },
    { icon: "trending_up", color: "#9C27B0",            bg: "#F3E5F5", label: t("routes.viewActivity"),            onClick: () => navigate("/viewactivity") },
    { icon: "person",      color: palette.orange[500], bg: "#FFF3E0", label: t("buttonTitles.goToProfile"),        onClick: () => navigate("/profile") },
  ];

  return (
    <>
      {/* Payment reminder dialog */}
      <Dialog open={showPaymentReminder} onClose={handleClosePaymentReminder} maxWidth="xs" fullWidth PaperProps={{ sx: { borderRadius: "24px", overflow: "hidden" } }}>
        <MDBox sx={{ px: 4, pt: 5, pb: 4, textAlign: "center" }}>
          <MDBox sx={{ width: 64, height: 64, borderRadius: "50%", bgcolor: "#FFF3E0", display: "flex", alignItems: "center", justifyContent: "center", mx: "auto", mb: 2 }}>
            <Icon sx={{ fontSize: "32px !important", color: palette.orange[500] }}>credit_card_off</Icon>
          </MDBox>
          <MDTypography variant="h6" fontWeight="bold" mb={1}>{t("alerts.payment.noPaymentMethodTitle")}</MDTypography>
          <MDTypography variant="body2" color="text.secondary" mb={3}>{t("alerts.payment.noPaymentMethodMessage")}</MDTypography>
          <MDBox display="flex" gap={2}>
            <Button variant="outlined" fullWidth onClick={handleClosePaymentReminder} sx={{ borderRadius: "12px", py: 1.25, textTransform: "none", color: palette.neutral[600], borderColor: palette.neutral[300] }}>{t("buttonTitles.close")}</Button>
            <Button variant="contained" fullWidth onClick={handleGoToAddPaymentMethod} sx={{ borderRadius: "12px", py: 1.25, textTransform: "none", bgcolor: palette.orange[500], color: "#fff", "&:hover": { bgcolor: palette.orange[600] } }}>{t("buttonTitles.addPaymentMethod")}</Button>
          </MDBox>
        </MDBox>
      </Dialog>

      <AdultOnBoardingScreen role="guardian" setOpenLoader={setOpenLoader} tabIndex={0} />
      <DashboardLayout>
        <DashboardNavbar title={t("pageTitles.dashboard")} role="navigation" tabIndex={0} />

        {openLoader && (
          <LoadingDataDialog openLoader={openLoader} setOpenLoader={setOpenLoader} loadLearners={loadLearners} t={t}
            onComplete={() => {
              if (isSharedAccount && profile.payment_status === "pending") navigate("/profile", { state: { openPayment: true } });
              else navigate("/profile", { state: { openManagePaymentMethod: true } });
            }}
          />
        )}

        {showInsightBar && (
          <MDBox mt={2.5}
            sx={{
              display: "flex", alignItems: "center", gap: 2,
              px: 2.5, py: 1.75, borderRadius: 3,
              bgcolor: "#E8F6F8",
              border: "1px solid #B2E4EC",
            }}
          >
            {/* Icon tile */}
            <MDBox sx={{ width: 44, height: 44, borderRadius: "12px", bgcolor: "#C8EEF4", display: "flex", alignItems: "center", justifyContent: "center", flexShrink: 0 }}>
              <Icon sx={{ color: "#00ACC1", fontSize: "22px !important" }}>ios_share</Icon>
            </MDBox>

            {/* Text */}
            <MDBox flex={1} minWidth={0}>
              <MDTypography variant="body2" fontWeight="bold" sx={{ color: "#004D5B", lineHeight: 1.3 }}>
                {t("notifications.unsharedInsights.youHave", { count: insightsCount })}
              </MDTypography>
              <MDTypography variant="caption" sx={{ color: "#00838F" }}>
                {t("notifications.unsharedInsights.subHeading")}
              </MDTypography>
            </MDBox>

            {/* Dismiss */}
            <IconButton size="small" onClick={() => setShowInsightBar(false)}
              sx={{ color: "#00ACC1", flexShrink: 0, "&:hover": { bgcolor: "#C8EEF4" } }}>
              <Icon sx={{ fontSize: "18px !important" }}>close</Icon>
            </IconButton>
          </MDBox>
        )}

        <MDBox mt={3}>
          {/* ── 4 stat cards ── */}
          <Grid container spacing={2.5} mb={3}>
            {statCards.map((card, i) => (
              <Grid item xs={12} sm={6} lg={3} key={i}>
                <Card onClick={card.onClick} sx={{ p: 2.5, borderRadius: 3, cursor: card.onClick ? "pointer" : "default", boxShadow: "0 2px 12px rgba(0,0,0,0.07)", transition: "all 200ms", "&:hover": card.onClick ? { transform: "translateY(-2px)", boxShadow: "0 6px 20px rgba(0,0,0,0.12)" } : {} }}>
                  <MDBox display="flex" justifyContent="space-between" alignItems="flex-start" mb={1.5}>
                    <MDBox sx={{ width: 52, height: 52, borderRadius: "16px", bgcolor: card.bg, display: "flex", alignItems: "center", justifyContent: "center" }}>
                      <Icon sx={{ color: card.color, fontSize: "28px !important" }}>{card.icon}</Icon>
                    </MDBox>
                    <Icon sx={{ color: "text.disabled", fontSize: "20px !important" }}>chevron_right</Icon>
                  </MDBox>
                  {loader ? (
                    <CircularProgress size={22} sx={{ color: card.color, mb: 0.5 }} />
                  ) : (
                    <MDTypography variant="h3" fontWeight="bold" sx={{ color: card.color, lineHeight: 1 }}>{card.count}</MDTypography>
                  )}
                  <MDTypography variant="body2" fontWeight="bold" mt={0.5}>{card.label}</MDTypography>
                  <MDTypography variant="caption" color="text.secondary">{card.sub}</MDTypography>
                  <MDBox mt={1.5}><MiniWave color={card.color} /></MDBox>
                </Card>
              </Grid>
            ))}
          </Grid>

          {/* ── Overview + Quick Links ── */}
          <Grid container spacing={2.5} mb={3}>
            {/* User Overview */}
            <Grid item xs={12} md={4}>
              <Card sx={{ p: 3, borderRadius: 3, height: "100%", boxShadow: "0 2px 8px rgba(0,0,0,0.06)" }}>
                <MDTypography variant="h6" fontWeight="bold" mb={2.5}>{t("headings.userOverview")}</MDTypography>
                {dashboardMetrics ? (
                  <MDBox display="flex" alignItems="center" gap={3}>
                    <DonutChart
                      segments={[
                        { color: palette.brand[500], value: activeLearners },
                        { color: palette.orange[500], value: inactiveLearners },
                      ]}
                      total={totalLearners}
                      centerLabel="Total Learners"
                    />
                    <MDBox flex={1}>
                      <MDBox display="flex" alignItems="center" gap={1} mb={2.5}>
                        <Icon sx={{ color: palette.brand[500], fontSize: "30px !important" }}>how_to_reg</Icon>
                        <MDBox>
                          <MDTypography variant="caption" color="text.secondary">{t("cardTitles.activeLearners")}</MDTypography>
                          <MDTypography variant="h5" fontWeight="bold" lineHeight={1.1}>{activeLearners}</MDTypography>
                          <MDTypography variant="caption" color="text.secondary">{activePct}% of total learners</MDTypography>
                        </MDBox>
                      </MDBox>
                      <MDBox display="flex" alignItems="center" gap={1}>
                        <Icon sx={{ color: palette.orange[500], fontSize: "30px !important" }}>person_off</Icon>
                        <MDBox>
                          <MDTypography variant="caption" color="text.secondary">{t("cardTitles.inactiveLearners")}</MDTypography>
                          <MDTypography variant="h5" fontWeight="bold" lineHeight={1.1}>{inactiveLearners}</MDTypography>
                          <MDTypography variant="caption" color="text.secondary">{inactivePct}% of total learners</MDTypography>
                        </MDBox>
                      </MDBox>
                    </MDBox>
                  </MDBox>
                ) : (
                  <MDBox display="flex" justifyContent="center" py={5}><CircularProgress sx={{ color: palette.brand[500] }} /></MDBox>
                )}
              </Card>
            </Grid>

            {/* Assessment Overview */}
            <Grid item xs={12} md={4}>
              <Card sx={{ p: 3, borderRadius: 3, height: "100%", boxShadow: "0 2px 8px rgba(0,0,0,0.06)" }}>
                <MDTypography variant="h6" fontWeight="bold" mb={2.5}>{t("headings.assessmentOverview")}</MDTypography>
                {loader ? (
                  <MDBox display="flex" justifyContent="center" py={5}><CircularProgress sx={{ color: palette.brand[500] }} /></MDBox>
                ) : (
                  <>
                    <MDBox display="flex" alignItems="center" gap={2}>
                      <DonutChart
                        segments={[
                          { color: palette.brand[500],  value: insightsCount },
                          { color: palette.purple[500], value: assessmentInProgress },
                          { color: palette.orange[500], value: assessmentNotStarted },
                          { color: palette.green[500],  value: assessmentNotGenerated },
                        ]}
                        total={totalAssessments}
                        centerLabel="Total Assessments"
                      />
                      <MDBox flex={1}>
                        {[
                          { label: t("userDynamicData.ready"),         value: insightsCount,          color: palette.brand[500] },
                          { label: t("userDynamicData.in_progress"),   value: assessmentInProgress,   color: palette.purple[500] },
                          { label: t("userDynamicData.not_started"),   value: assessmentNotStarted,   color: palette.orange[500] },
                          { label: t("userDynamicData.not_generated"), value: assessmentNotGenerated, color: palette.green[500] },
                        ].map((item) => (
                          <MDBox key={item.label} display="flex" alignItems="center" justifyContent="space-between" mb={1}>
                            <MDBox display="flex" alignItems="center" gap={0.75}>
                              <MDBox sx={{ width: 10, height: 10, borderRadius: "50%", bgcolor: item.color, flexShrink: 0 }} />
                              <MDTypography variant="caption">{item.label}</MDTypography>
                            </MDBox>
                            <MDTypography variant="caption" fontWeight="bold">
                              {item.value} ({totalAssessments ? Math.round((item.value / totalAssessments) * 100) : 0}%)
                            </MDTypography>
                          </MDBox>
                        ))}
                      </MDBox>
                    </MDBox>
                    {/* <Divider sx={{ my: 2 }} />
                    <MDBox display="flex" alignItems="center" gap={0.5} sx={{ cursor: "pointer" }} onClick={() => navigate("/viewactivity")}>
                      <MDTypography variant="body2" fontWeight="bold" sx={{ color: palette.brand[500] }}>{t("buttonTitles.viewAllAssessments")}</MDTypography>
                      <Icon sx={{ fontSize: "18px !important", color: palette.brand[500] }}>arrow_forward</Icon>
                    </MDBox> */}
                  </>
                )}
              </Card>
            </Grid>

            {/* Quick Links */}
            <Grid item xs={12} md={4}>
              <Card sx={{ p: 3, borderRadius: 3, height: "100%", boxShadow: "0 2px 8px rgba(0,0,0,0.06)" }}>
                <MDTypography variant="h6" fontWeight="bold" mb={2}>{t("headings.quickLinks")}</MDTypography>
                <Stack spacing={0.5}>
                  {quickLinks.map((link) => (
                    <MDBox key={link.label} onClick={link.onClick} display="flex" alignItems="center" gap={2}
                      sx={{ p: 1.5, borderRadius: "12px", cursor: "pointer", transition: "all 160ms", "&:hover": { bgcolor: palette.neutral[50] } }}>
                      <MDBox sx={{ width: 40, height: 40, borderRadius: "12px", bgcolor: link.bg, display: "flex", alignItems: "center", justifyContent: "center", flexShrink: 0 }}>
                        <Icon sx={{ color: link.color, fontSize: "20px !important" }}>{link.icon}</Icon>
                      </MDBox>
                      <MDTypography variant="body2" fontWeight="bold" sx={{ flex: 1 }}>{link.label}</MDTypography>
                      <Icon sx={{ color: "text.disabled", fontSize: "18px !important" }}>chevron_right</Icon>
                    </MDBox>
                  ))}
                </Stack>
              </Card>
            </Grid>
          </Grid>

          {/* ── Athletes table ── */}
          <Card sx={{ p: 3, borderRadius: 3, boxShadow: "0 2px 8px rgba(0,0,0,0.06)" }}>
            {/* Table header — matches ChildrenTable style */}
            <MDBox display="flex" alignItems="center" justifyContent="space-between" mb={1} flexWrap="wrap" gap={1.5}
              tabIndex={0} role="Table Heading" aria-label="Athletes">
              <MDBox display="flex" alignItems="center" gap={1.5}>
                <MDBox sx={{ width: 44, height: 44, borderRadius: "12px", bgcolor: `${palette.brand[500]}18`, display: "flex", alignItems: "center", justifyContent: "center", flexShrink: 0 }}>
                  <Icon sx={{ color: palette.brand[500], fontSize: "22px !important" }}>supervisor_account</Icon>
                </MDBox>
                <MDBox>
                  <MDTypography variant="h5" fontWeight="bold" lineHeight={1.2}>{t("headings.athletes")}</MDTypography>
                  <MDTypography variant="caption" color="text.secondary">{t("messages.dashboard.athletesSubtitle")}</MDTypography>
                </MDBox>
              </MDBox>
            </MDBox>
            <DataTable hasFilters={true} table={tableData} filters={filters} setOpenFilterModel={setOpenFilterModel}
              loader={loader} pageNumber={pageNumber} setPageNumber={setPageNumber} canSearch={true} />
          </Card>
        </MDBox>

        {/* ── Dialogs (unchanged) ── */}
        {!!controlAccessRow && (
          <ControlAccessDialog controlAccessRow={controlAccessRow} closeControlAccessDialog={closeControlAccessDialog}
            loadLearners={loadLearners} profile={profile} setOpenSnackbar={setOpenSnackbar} setAlertMessage={setAlertMessage} t={t} />
        )}
        {!!openFilterModel && (
          <FilterViewDialog filters={filters} openFilterModel={openFilterModel} filterCloseHandler={filterCloseHandler}
            addFilterOpenHandler={addFilterOpenHandler} editFilterOpenHandler={editFilterOpenHandler} deleteFilterOpenHandler={deleteFilterOpenHandler} t={t} />
        )}
        {!!openAddFilterModel && (
          <FilterAddDialog openAddFilterModel={openAddFilterModel} addFilterCloseHandler={addFilterCloseHandler}
            setFilters={setFilters} filters={filters} tableData={tableData} profile={profile}
            setOpenSnackbar={setOpenSnackbar} setAlertMessage={setAlertMessage} loadFilters={loadFilters} t={t} />
        )}
        {!!openEditFilterModel && (
          <FilterEditDialog openEditFilterModel={openEditFilterModel} editFilterCloseHandler={editFilterCloseHandler}
            editFilterData={editFilterData} setFilters={setFilters} filters={filters} tableData={tableData}
            setOpenSnackbar={setOpenSnackbar} setAlertMessage={setAlertMessage} loadFilters={loadFilters} t={t} />
        )}
        {!!openDeleteFilterModel && !!deleteFilterData && (
          <ConfirmDialog
            open={openDeleteFilterModel}
            onClose={deleteFilterCloseHandler}
            onConfirm={handleDeleteFilter}
            title={t("headings.deleteFilter", { name: deleteFilterData.name })}
            message={t("messages.dashboard.deleteFilter")}
            confirmLabel={t("buttonTitles.delete")}
            cancelLabel={t("buttonTitles.cancel")}
            loading={deleteFilterLoading}
            dangerous
            icon="delete"
          />
        )}
        {showBot && chatQuestions.length > 0 && (
          <Bot showUnreadChat={showUnreadChat} setShowUnreadChat={setShowUnreadChat} showTodayContent={showTodayContent}
            todayContent={todayContent} chatQuestions={chatQuestions} showIntro={showIntro}
            userMetricsData={userMetricsData} setUserMetricsData={setUserMetricsData}
            autoExpandBot={autoExpandBot} profile={profile} />
        )}
        <Snackbar autoHideDuration={2000} open={openSnackbar} onClose={handleCloseSnackbar} anchorOrigin={{ vertical: "bottom", horizontal: "center" }}>
          <Alert onClose={handleCloseSnackbar} severity={severity} sx={{ width: "100%" }}>{alertMessage}</Alert>
        </Snackbar>
      </DashboardLayout>
    </>
  );
}

const LoadingDataDialog = ({ setOpenLoader, openLoader, loadLearners, t, onComplete }) => {
  useEffect(() => {
    setTimeout(() => {
      loadLearners();
      setOpenLoader(false);
      if (onComplete) onComplete();
    }, 8000);
  }, []);

  return (
    <Dialog open={openLoader} fullScreen>
      <DialogContent>
        <Loader loaderText={t("loaderText.settingAccount")} />
      </DialogContent>
    </Dialog>
  );
};

const ControlAccessDialog = ({
  controlAccessRow,
  closeControlAccessDialog,
  loadLearners,
  profile,
  setOpenSnackbar,
  setAlertMessage,
  t,
}) => {
  const [emailVal, setEmailVal] = useState("");
  const [sharing, setSharing] = useState(false);

  const shareInsightAccessHandler = (e) => {
    e.preventDefault();
    setSharing(true);
    call(`users/${controlAccessRow.learner_id}/assessments/${controlAccessRow.assessment_id}`, "PUT", {
      body: { user_email: emailVal, action: "grant_access" },
    })
      .then((response) => {
        if (response.status == 200) {
          setAlertMessage(t("alerts.dashboard.inviteSuccess"));
          setOpenSnackbar(true);
          loadLearners();
          closeControlAccessDialog();
        } else if (response.status == 440) {
          closeControlAccessDialog();
        } else {
          setAlertMessage(t("alerts.dashboard.inviteError"));
          setOpenSnackbar(true);
          closeControlAccessDialog();
        }
      })
      .catch((err) => {
        setAlertMessage(t("alerts.dashboard.inviteError"));
        setOpenSnackbar(true);
        Sentry.captureException(err);
        closeControlAccessDialog();
      })
      .finally(() => setSharing(false));
  };

  const deleteInsightAccessHandler = (user_id) => {
    call(`users/${controlAccessRow.learner_id}/assessments/${controlAccessRow.assessment_id}`, "PUT", {
      body: { revoke_id: user_id, action: "revoke_access" },
    })
      .then((response) => {
        if (response.status == 200) {
          setAlertMessage(t("alerts.dashboard.removedAccess"));
          setOpenSnackbar(true);
          loadLearners();
          closeControlAccessDialog();
        } else if (response.status == 440) {
          closeControlAccessDialog();
        } else {
          setAlertMessage(t("alerts.dashboard.removedAccessError"));
          setOpenSnackbar(true);
          closeControlAccessDialog();
        }
      })
      .catch((err) => {
        setAlertMessage(t("alerts.dashboard.removedAccessError"));
        setOpenSnackbar(true);
        Sentry.captureException(err);
        closeControlAccessDialog();
      });
  };

  const sendNotificationHandler = (recipient_id) => {
    call(`users/${profile.id}/emails`, "POST", {
      body: { email_type: "send_insights_reminder_notification", recipient_id },
    })
      .then((response) => {
        setAlertMessage(
          response.status == 200
            ? t("alerts.dashboard.insightReminderSuccess")
            : t("alerts.dashboard.insightReminderError")
        );
        setOpenSnackbar(true);
      })
      .catch((err) => {
        setAlertMessage(t("alerts.dashboard.insightReminderError"));
        setOpenSnackbar(true);
        Sentry.captureException(err);
      });
  };

  const getInitials = (name = "") =>
    name.split(" ").map((n) => n[0]).join("").substring(0, 2).toUpperCase();

  const roleChipFor = (share) => {
    if (share.is_guardian || share.user_id === profile.id)
      return <Chip label={t("userDynamicData.owner")} size="small" sx={{ bgcolor: "#e8f5e9", color: "#4caf50", fontWeight: "bold", fontSize: "0.68rem", height: 22 }} />;
    if (profile.relationships.children?.includes(share.user_id) || profile.relationships.athletes?.includes(share.user_id))
      return <Chip label={t("userDynamicData.learner")} size="small" sx={{ bgcolor: `${palette.brand[500]}18`, color: palette.brand[500], fontWeight: "bold", fontSize: "0.68rem", height: 22 }} />;
    if (profile.relationships.coaches?.includes(share.user_id))
      return <Chip label={t("userDynamicData.coach")} size="small" sx={{ bgcolor: "#ede7f6", color: "#9c27b0", fontWeight: "bold", fontSize: "0.68rem", height: 22 }} />;
    return null;
  };

  const fieldSx = { "& .MuiOutlinedInput-root": { borderRadius: "12px", bgcolor: "#fafafa" } };

  return (
    <Dialog open={!!controlAccessRow} onClose={closeControlAccessDialog} maxWidth="sm" fullWidth
      PaperProps={{ sx: { borderRadius: "24px", overflow: "hidden" } }}>

      {/* Circle close */}
      <MDBox onClick={closeControlAccessDialog} sx={{ position: "absolute", top: 12, right: 12, zIndex: 10, width: 36, height: 36, borderRadius: "50%", bgcolor: "rgba(0,0,0,0.06)", border: "1px solid rgba(0,0,0,0.08)", display: "flex", alignItems: "center", justifyContent: "center", cursor: "pointer", "&:hover": { bgcolor: "rgba(0,0,0,0.1)" } }}>
        <Icon sx={{ fontSize: "18px !important", color: "text.secondary" }}>close</Icon>
      </MDBox>

      <MDBox sx={{ px: 4, pt: 5, pb: 4 }}>
        {/* Header */}
        <MDBox textAlign="center" mb={3}>
          <MDBox sx={{ width: 64, height: 64, borderRadius: "50%", bgcolor: `${palette.brand[500]}18`, display: "flex", alignItems: "center", justifyContent: "center", mx: "auto", mb: 2 }}>
            <Icon sx={{ fontSize: "32px !important", color: palette.brand[500] }}>folder_shared</Icon>
          </MDBox>
          <MDTypography variant="h5" fontWeight="bold" lineHeight={1.3} mb={0.5}>
            {controlAccessRow?.learner_name}
          </MDTypography>
          <MDTypography variant="caption" color="text.secondary">
            {controlAccessRow?.assessment_name}
          </MDTypography>
        </MDBox>

        {/* Invite section */}
        <MDBox mb={3}>
          <MDTypography variant="body2" fontWeight="bold" mb={0.75}>
            {t("formLabels.email")} <span style={{ color: "#f44336" }}>*</span>
          </MDTypography>
          <MDBox display="flex" gap={1} component="form" onSubmit={shareInsightAccessHandler}>
            <TextField
              type="email" fullWidth size="small" required
              placeholder={t("formPlaceHolders.email")}
              value={emailVal}
              onChange={(e) => setEmailVal(e.target.value)}
              sx={fieldSx}
            />
            <Button type="submit" variant="contained" disabled={sharing}
              sx={{ borderRadius: "12px", px: 2.5, textTransform: "none", bgcolor: palette.brand[500], color: "#fff", fontWeight: "bold", whiteSpace: "nowrap", flexShrink: 0, "&:hover": { bgcolor: palette.brand[600] } }}>
              {sharing ? <CircularProgress size={18} color="inherit" /> : t("buttonTitles.share")}
            </Button>
          </MDBox>
        </MDBox>

        <Divider sx={{ mb: 2 }} />

        {/* People with access */}
        <MDTypography variant="body2" fontWeight="bold" mb={1.5}>
          {t("headings.peopleWithAccess")}
        </MDTypography>

        <MDBox sx={{ maxHeight: 280, overflowY: "auto", mx: -1 }}>
          {controlAccessRow.shared_with.map((share) => {
            const chip = roleChipFor(share);
            const isExternal = !chip;

            return (
              <MDBox key={share.user_id} display="flex" alignItems="center" gap={1.5}
                sx={{ px: 1.5, py: 1.1, borderRadius: "12px", mb: 0.5, transition: "background 160ms", "&:hover": { bgcolor: "rgba(0,0,0,0.025)" } }}>
                <Avatar sx={{ width: 36, height: 36, bgcolor: palette.brand[50], color: palette.brand[400], fontSize: "0.75rem", fontWeight: "bold", flexShrink: 0 }}>
                  {getInitials(share.name) || <Icon sx={{ fontSize: "18px !important" }}>person</Icon>}
                </Avatar>
                <MDBox flex={1} minWidth={0}>
                  <MDTypography variant="body2" fontWeight="medium" noWrap>{share.name}</MDTypography>
                  {isExternal && share.expiration && (
                    <MDTypography variant="caption" color="text.secondary">
                      {t("tableHeaders.expiration")}: {share.expiration}
                    </MDTypography>
                  )}
                </MDBox>
                {chip}
                {isExternal && (
                  <MDBox display="flex" gap={0.25} flexShrink={0}>
                    <Tooltip title={<h2>{t("toolTips.removeAccess")}</h2>}>
                      <IconButton size="small" onClick={() => deleteInsightAccessHandler(share.user_id)} sx={{ color: "#f44336" }}>
                        <Icon sx={{ fontSize: "18px !important" }}>person_remove</Icon>
                      </IconButton>
                    </Tooltip>
                    {share.status === "inactive" && (
                      <Tooltip title={<h2>{t("toolTips.sendNotification")}</h2>}>
                        <IconButton size="small" onClick={() => sendNotificationHandler(share.user_id)} sx={{ color: palette.brand[500] }}>
                          <Icon sx={{ fontSize: "18px !important" }}>mail</Icon>
                        </IconButton>
                      </Tooltip>
                    )}
                  </MDBox>
                )}
              </MDBox>
            );
          })}
        </MDBox>

        {/* Footer */}
        <MDBox mt={2.5}>
          <Button fullWidth variant="outlined" onClick={closeControlAccessDialog}
            sx={{ borderRadius: "12px", py: 1.25, textTransform: "none", borderColor: "rgba(0,0,0,0.15)", color: "text.secondary", fontWeight: "bold" }}>
            {t("buttonTitles.cancel")}
          </Button>
        </MDBox>
      </MDBox>
    </Dialog>
  );
};

// Updating the existing Filter Data
const FilterEditDialog = ({
  openEditFilterModel,
  editFilterCloseHandler,
  editFilterData,
  setFilters,
  filters,
  tableData,
  setOpenSnackbar,
  setAlertMessage,
  loadFilters,
  t,
}) => {
  const [data, setData] = useState(null);
  const [nameVal, setNameVal] = useState(editFilterData.name);
  const [saving, setSaving] = useState(false);
  const icon = <CheckBoxOutlineBlankIcon fontSize="small" />;
  const checkedIcon = <CheckBoxIcon fontSize="small" />;

  const cleanRows = tableData.rows.map(({ learner_id, learner_name }) => ({ learner_id, learner_name }));

  const defaultOptions = () => {
    const members = editFilterData.members;
    const options = members.flatMap((id) => cleanRows.filter((r) => r.learner_id == id));
    return [...new Map(options.map((r) => [r.learner_id, r])).values()];
  };

  const getOptions = () => [...new Map(cleanRows.map((r) => [r.learner_id, r])).values()];

  const editFilterHandler = () => {
    const newMembers = data == null
      ? editFilterData.members
      : data.map((a) => a.learner_id);

    setSaving(true);
    call(`filters/${editFilterData.id}`, "PUT", {
      body: { pk: editFilterData.pk, sk: editFilterData.sk, id: editFilterData.id, name: nameVal, owner: editFilterData.owner, members: newMembers },
      headers: { "Content-Type": "application/json" },
    })
      .then((res) => {
        if (res.status == 200) {
          setOpenSnackbar(true);
          setAlertMessage(t("alerts.dashboard.filterUpdatedSuccessfully"));
          loadFilters();
          editFilterCloseHandler();
        } else if (res.status == 440) {
          editFilterCloseHandler();
        } else {
          setOpenSnackbar(true);
          setAlertMessage(t("alerts.dashboard.filterUpdatedError"));
          editFilterCloseHandler();
        }
      })
      .catch((err) => {
        setOpenSnackbar(true);
        setAlertMessage(t("alerts.dashboard.filterUpdatedError"));
        Sentry.captureException(err);
      })
      .finally(() => setSaving(false));
  };

  const fieldSx = { "& .MuiOutlinedInput-root": { borderRadius: "12px", bgcolor: "#fafafa" } };

  return (
    <Dialog open={openEditFilterModel} onClose={editFilterCloseHandler} maxWidth="sm" fullWidth
      PaperProps={{ sx: { borderRadius: "24px", overflow: "hidden" } }}>

      {/* Circle close */}
      <MDBox onClick={editFilterCloseHandler} sx={{ position: "absolute", top: 12, right: 12, zIndex: 10, width: 36, height: 36, borderRadius: "50%", bgcolor: "rgba(0,0,0,0.06)", border: "1px solid rgba(0,0,0,0.08)", display: "flex", alignItems: "center", justifyContent: "center", cursor: "pointer", "&:hover": { bgcolor: "rgba(0,0,0,0.1)" } }}>
        <Icon sx={{ fontSize: "18px !important", color: "text.secondary" }}>close</Icon>
      </MDBox>

      <MDBox sx={{ px: 4, pt: 5, pb: 4 }}>
        {/* Header */}
        <MDBox textAlign="center" mb={3}>
          <MDBox sx={{ width: 64, height: 64, borderRadius: "50%", bgcolor: `${palette.brand[500]}18`, display: "flex", alignItems: "center", justifyContent: "center", mx: "auto", mb: 2 }}>
            <Icon sx={{ fontSize: "32px !important", color: palette.brand[500] }}>edit</Icon>
          </MDBox>
          <MDTypography variant="h5" fontWeight="bold">{t("headings.editFilter", { name: editFilterData.name })}</MDTypography>
        </MDBox>

        {/* Name */}
        <MDBox mb={2.5}>
          <MDTypography variant="body2" fontWeight="bold" mb={0.75}>
            {t("formLabels.name")} <span style={{ color: "#f44336" }}>*</span>
          </MDTypography>
          <TextField fullWidth size="small" placeholder={t("formPlaceHolders.filterName")}
            value={nameVal} onChange={(e) => setNameVal(e.target.value)} sx={fieldSx} />
        </MDBox>

        {/* Athletes */}
        <MDBox mb={3.5}>
          <MDTypography variant="body2" fontWeight="bold" mb={0.75}>
            {t("formLabels.athletes")} <span style={{ color: "#f44336" }}>*</span>
          </MDTypography>
          <Autocomplete
            multiple disableCloseOnSelect
            defaultValue={defaultOptions()}
            options={getOptions()}
            onChange={(event, newValue) => setData(newValue)}
            getOptionLabel={(option) => option.learner_name}
            renderOption={(props, option, { selected }) => (
              <li {...props}>
                <Checkbox icon={icon} checkedIcon={checkedIcon} style={{ marginRight: 8 }} checked={selected} />
                {option.learner_name}
              </li>
            )}
            renderInput={(params) => (
              <TextField {...params} placeholder={t("formPlaceHolders.athletes")} sx={fieldSx} />
            )}
            fullWidth
          />
        </MDBox>

        {/* Actions */}
        <MDBox display="flex" gap={2}>
          <Button fullWidth variant="outlined" onClick={editFilterCloseHandler}
            sx={{ borderRadius: "12px", py: 1.5, textTransform: "none", borderColor: "rgba(0,0,0,0.15)", color: "text.secondary", fontWeight: "bold" }}>
            {t("buttonTitles.cancel")}
          </Button>
          <Button fullWidth variant="contained" onClick={editFilterHandler}
            disabled={saving || nameVal === ""}
            sx={{ borderRadius: "12px", py: 1.5, textTransform: "none", bgcolor: palette.brand[500], color: "#fff", fontWeight: "bold", "&:hover": { bgcolor: palette.brand[600] }, "&.Mui-disabled": { bgcolor: "rgba(0,0,0,0.12)", color: "rgba(0,0,0,0.38)" } }}>
            {saving ? <CircularProgress size={20} color="inherit" /> : t("buttonTitles.save")}
          </Button>
        </MDBox>
      </MDBox>
    </Dialog>
  );
};

// Adding the New Filters
const FilterAddDialog = ({
  openAddFilterModel,
  addFilterCloseHandler,
  setFilters,
  filters,
  tableData,
  profile,
  setOpenSnackbar,
  setAlertMessage,
  loadFilters,
  t,
}) => {
  const [nameVal, setNameVal] = useState("");
  const [newFilter, setNewFilter] = useState([]);
  const icon = <CheckBoxOutlineBlankIcon fontSize="small" />;
  const checkedIcon = <CheckBoxIcon fontSize="small" />;

  const addFilterHandler = () => {
    const members = newFilter.map((at) => at.learner_id);
    call(`filters/`, "POST", { body: { owner: profile.id, name: nameVal, members } })
      .then((res) => {
        if (res.status == 200) {
          setOpenSnackbar(true);
          setAlertMessage(t("alerts.dashboard.filterAddedSuccessfully"));
          loadFilters();
          addFilterCloseHandler();
        } else if (res.status == 440) {
          addFilterCloseHandler();
        } else {
          setOpenSnackbar(true);
          setAlertMessage(t("alerts.dashboard.filterAddedError"));
          loadFilters();
          addFilterCloseHandler();
        }
      })
      .catch((err) => {
        Sentry.captureException(err);
        setOpenSnackbar(true);
        setAlertMessage(t("alerts.dashboard.filterAddedError"));
      });
  };

  const getOptions = () => {
    const clean = tableData.rows.map(({ learner_id, learner_name }) => ({ learner_id, learner_name }));
    return [...new Map(clean.map((r) => [r.learner_id, r])).values()];
  };

  const fieldSx = { "& .MuiOutlinedInput-root": { borderRadius: "12px", bgcolor: "#fafafa" } };

  return (
    <Dialog open={openAddFilterModel} onClose={addFilterCloseHandler} maxWidth="sm" fullWidth
      PaperProps={{ sx: { borderRadius: "24px", overflow: "hidden" } }}>

      {/* Circle close */}
      <MDBox onClick={addFilterCloseHandler} sx={{ position: "absolute", top: 12, right: 12, zIndex: 10, width: 36, height: 36, borderRadius: "50%", bgcolor: "rgba(0,0,0,0.06)", border: "1px solid rgba(0,0,0,0.08)", display: "flex", alignItems: "center", justifyContent: "center", cursor: "pointer", "&:hover": { bgcolor: "rgba(0,0,0,0.1)" } }}>
        <Icon sx={{ fontSize: "18px !important", color: "text.secondary" }}>close</Icon>
      </MDBox>

      <MDBox sx={{ px: 4, pt: 5, pb: 4 }}>
        {/* Header */}
        <MDBox textAlign="center" mb={3}>
          <MDBox sx={{ width: 64, height: 64, borderRadius: "50%", bgcolor: `${palette.brand[500]}18`, display: "flex", alignItems: "center", justifyContent: "center", mx: "auto", mb: 2 }}>
            <Icon sx={{ fontSize: "32px !important", color: palette.brand[500] }}>tune</Icon>
          </MDBox>
          <MDTypography variant="h5" fontWeight="bold">{t("headings.addFilter")}</MDTypography>
        </MDBox>

        {/* Name */}
        <MDBox mb={2.5}>
          <MDTypography variant="body2" fontWeight="bold" mb={0.75}>
            {t("formLabels.name")} <span style={{ color: "#f44336" }}>*</span>
          </MDTypography>
          <TextField fullWidth size="small" placeholder={t("formPlaceHolders.filterName")}
            value={nameVal} onChange={(e) => setNameVal(e.target.value)} sx={fieldSx} />
        </MDBox>

        {/* Athletes */}
        <MDBox mb={3.5}>
          <MDTypography variant="body2" fontWeight="bold" mb={0.75}>
            {t("formLabels.athletes")} <span style={{ color: "#f44336" }}>*</span>
          </MDTypography>
          <Autocomplete
            multiple disableCloseOnSelect
            options={getOptions()}
            onChange={(event, newValue) => setNewFilter(newValue)}
            getOptionLabel={(option) => option.learner_name}
            renderOption={(props, option, { selected }) => (
              <li {...props}>
                <Checkbox icon={icon} checkedIcon={checkedIcon} style={{ marginRight: 8 }} checked={selected} />
                {option.learner_name}
              </li>
            )}
            renderInput={(params) => (
              <TextField {...params} placeholder={t("formPlaceHolders.athletes")} sx={fieldSx} />
            )}
            fullWidth
          />
        </MDBox>

        {/* Actions */}
        <MDBox display="flex" gap={2}>
          <Button fullWidth variant="outlined" onClick={addFilterCloseHandler}
            sx={{ borderRadius: "12px", py: 1.5, textTransform: "none", borderColor: "rgba(0,0,0,0.15)", color: "text.secondary", fontWeight: "bold" }}>
            {t("buttonTitles.cancel")}
          </Button>
          <Button fullWidth variant="contained" onClick={addFilterHandler}
            disabled={newFilter.length === 0 || nameVal === ""}
            sx={{ borderRadius: "12px", py: 1.5, textTransform: "none", bgcolor: palette.brand[500], color: "#fff", fontWeight: "bold", "&:hover": { bgcolor: palette.brand[600] }, "&.Mui-disabled": { bgcolor: "rgba(0,0,0,0.12)", color: "rgba(0,0,0,0.38)" } }}>
            {t("buttonTitles.add")}
          </Button>
        </MDBox>
      </MDBox>
    </Dialog>
  );
};

// View All the Available Filters
const FilterViewDialog = ({
  openFilterModel,
  filterCloseHandler,
  filters,
  addFilterOpenHandler,
  editFilterOpenHandler,
  deleteFilterOpenHandler,
  t,
}) => {
  return (
    <Dialog open={openFilterModel} onClose={filterCloseHandler} maxWidth="xs" fullWidth
      PaperProps={{ sx: { borderRadius: "20px", overflow: "hidden" } }}>

      {/* Header */}
      <MDBox sx={{ px: 3, pt: 3, pb: 2, display: "flex", alignItems: "center", justifyContent: "space-between" }}>
        <MDBox display="flex" alignItems="center" gap={1.5}>
          <MDBox sx={{ width: 42, height: 42, borderRadius: "12px", bgcolor: `${palette.brand[500]}18`, display: "flex", alignItems: "center", justifyContent: "center", flexShrink: 0 }}>
            <Icon sx={{ color: palette.brand[500], fontSize: "22px !important" }}>tune</Icon>
          </MDBox>
          <MDBox>
            <MDTypography variant="h6" fontWeight="bold" lineHeight={1.2}>{t("headings.filtersData")}</MDTypography>
            <MDTypography variant="caption" color="text.secondary">
              {filters.length} {filters.length === 1 ? "filter" : "filters"}
            </MDTypography>
          </MDBox>
        </MDBox>
        <IconButton size="small" onClick={filterCloseHandler} sx={{ color: "text.secondary" }}>
          <Icon>close</Icon>
        </IconButton>
      </MDBox>

      <Divider sx={{ mx: 0, my: 0 }} />

      {/* Filter list */}
      <MDBox sx={{ px: 2, py: 1.5, minHeight: 80, maxHeight: 380, overflowY: "auto" }}>
        {filters.length === 0 ? (
          <MDBox py={5} textAlign="center">
            <Icon sx={{ fontSize: "40px !important", color: "text.disabled", display: "block", mb: 1 }}>filter_none</Icon>
            <MDTypography variant="body2" color="text.secondary">{t("noData.noAvailableData")}</MDTypography>
          </MDBox>
        ) : (
          filters.map((filter) => (
            <MDBox key={filter.id} display="flex" alignItems="center"
              sx={{ px: 1.5, py: 1.1, borderRadius: "12px", mb: 0.75, border: "1px solid rgba(0,0,0,0.07)", transition: "background 160ms", "&:hover": { bgcolor: "rgba(0,0,0,0.025)" } }}>
              <MDBox sx={{ width: 32, height: 32, borderRadius: "9px", bgcolor: `${palette.brand[500]}12`, display: "flex", alignItems: "center", justifyContent: "center", mr: 1.5, flexShrink: 0 }}>
                <Icon sx={{ fontSize: "16px !important", color: palette.brand[500] }}>filter_list</Icon>
              </MDBox>
              <MDTypography variant="body2" fontWeight="medium" sx={{ flex: 1 }}>{filter.name}</MDTypography>
              <MDBox display="flex" gap={0.25}>
                <Tooltip title={<h2>{t("toolTips.edit")}</h2>}>
                  <IconButton size="small" onClick={() => editFilterOpenHandler(filter)} sx={{ color: palette.brand[500] }}>
                    <Icon sx={{ fontSize: "18px !important" }}>edit</Icon>
                  </IconButton>
                </Tooltip>
                <Tooltip title={<h2>{t("toolTips.delete")}</h2>}>
                  <IconButton size="small" onClick={() => deleteFilterOpenHandler(filter)} sx={{ color: "#f44336" }}>
                    <Icon sx={{ fontSize: "18px !important" }}>delete</Icon>
                  </IconButton>
                </Tooltip>
              </MDBox>
            </MDBox>
          ))
        )}
      </MDBox>

      {/* Footer */}
      <MDBox sx={{ px: 3, py: 2, borderTop: "1px solid rgba(0,0,0,0.06)", display: "flex", gap: 1.5 }}>
        <Button fullWidth variant="outlined" onClick={filterCloseHandler}
          sx={{ borderRadius: "12px", py: 1.25, textTransform: "none", borderColor: "rgba(0,0,0,0.15)", color: "text.secondary", fontWeight: "bold" }}>
          {t("buttonTitles.close")}
        </Button>
        <Button fullWidth variant="contained" onClick={addFilterOpenHandler}
          sx={{ borderRadius: "12px", py: 1.25, textTransform: "none", bgcolor: palette.brand[500], color: "#fff", fontWeight: "bold", gap: 0.5, "&:hover": { bgcolor: palette.brand[600] } }}>
          <Icon sx={{ fontSize: "18px !important" }}>add</Icon>
          {t("buttonTitles.addFilter")}
        </Button>
      </MDBox>
    </Dialog>
  );
};

function FormField({ label, name, ...rest }) {
  return (
    <MDBox mb={1.5}>
      <MDInput
        autoFocus
        {...rest}
        name={name}
        as={MDInput}
        variant="standard"
        label={label}
        fullWidth
      />
    </MDBox>
  );
}
